/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery');
import countries from '../../../services/country.json'
export default {
  name: 'unsubscribed-user-list',
  components: {},
  props: [],
  data () {
    return {
      countryList:[],
      unSubscribedUsers:{},
    }
  },
  computed: {
  ...mapGetters([
    'getUnsubscribedUserListGetters'
  ]),
  getUnsubscribedUserListFun(){
   this.unSubscribedUsers = this.$store.getters.getUnsubscribedUserListGetters.data
   return 
  },
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getUnsubscribedUserListFun
  },
  methods: {
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getUnsubscribedUserListFun(){
     return this.$store.getters.getUnsubscribedUserListGetters
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}